var LocalPager = (function () {
    function LocalPager() {
    }
    LocalPager.paginate = function (data, page, perPage) {
        return data.slice(perPage * (page - 1), perPage * page);
    };
    return LocalPager;
}());
export { LocalPager };
//# sourceMappingURL=local.pager.js.map


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/ng2-smart-table/lib/data-source/local/local.pager.js
// module id = ../../../../ng2-smart-table/lib/data-source/local/local.pager.js
// module chunks = 37